/** 微信与本地浏览器预览默认连正式服。本地可用 ?ws= 覆盖。 */
export const WS_URL = "wss://chengyu.storybuddy.fun/ws";
export const WS_URL_PLAIN = "wss://chengyu.storybuddy.fun/ws";
export const HTTP_BASE = "https://chengyu.storybuddy.fun";
export const HTTP_BASE_LOCAL = "http://127.0.0.1:3000";
export const LOCAL_WS = "ws://127.0.0.1:3000/ws";
